module.exports = __webpack_public_path__ + "img/google-btn.f221c33e.svg";